module.exports = __webpack_public_path__ + "static/media/13.London Tour.bcceb5d7.jpg";